import { Component, OnInit, inject } from '@angular/core';
import { LanguageService } from 'src/app/core/services/language.service';
import { UserInfoService } from 'src/app/core/services/user/user-info.service';
import { InstallAppService } from '../../../services/install-app.service';
import { BonusStoreService } from '../../../services/bonus-store.service';
import { TranslatePipe } from '../../../services/translation/translate.pipe';

import { RouterLinkDirective } from '../../directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { TextGradientComponent } from '../../components/text-gradient/text-gradient.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-bottom-navigation',
    templateUrl: './bottom-navigation.component.html',
    styleUrls: ['./bottom-navigation.component.scss'],
    imports: [TextGradientComponent, RouterLink, RouterLinkDirective, TranslatePipe, AsyncPipe]
})
export class BottomNavigationComponent implements OnInit {
  language = inject(LanguageService);
  user = inject(UserInfoService);
  installApp = inject(InstallAppService);
  bonusStore = inject(BonusStoreService);


  public get lang(): string {
    return this.language.current;
  }

  ngOnInit(): void {
  }

}
